{
  "title": "Inquilinos",
  "subtitle": "Todas las organizaciones de clientes en la plataforma",
  "subtitlePartnerView": "Clientes atribuidos a este socio",
  "addTenant": "Añadir inquilino",
  "onlyMspCanAdd": "Solo los administradores MSP pueden añadir inquilinos",
  "cannotAddTenant": "Necesita acceso de administrador MSP o de socio para añadir un inquilino",
  "loadError": "No se pudieron cargar los inquilinos",
  "emptyTitle": "Aún no hay inquilinos",
  "emptyDescription": "Un inquilino es una organización cliente. Al añadir uno se inicia el asistente de incorporación, que guía por el consentimiento, los conectores, un grupo piloto y la validación antes de tocar su correo.",
  "emptyTitlePartnerView": "Aún no hay clientes para este socio",
  "emptyDescriptionPartnerView": "Añada un cliente para abrir su incorporación. Los inquilinos nuevos creados aquí se atribuyen a este socio automáticamente.",
  "colTenant": "Inquilino",
  "colOnboarding": "Incorporación",
  "colStamping": "Estampado",
  "colDomains": "Dominios",
  "colSnapshot": "Instantánea",
  "noneSynced": "ninguno sincronizado",
  "orgName": "Nombre de la organización",
  "orgNamePlaceholder": "Contoso S.A.",
  "slug": "Slug",
  "slugDescription": "En minúsculas; se usa en las URL y en el asunto del certificado del inquilino. No se puede cambiar una vez iniciada la incorporación.",
  "slugError": "Solo letras minúsculas, dígitos y guiones.",
  "createError": "No se pudo crear el inquilino",
  "onboardingStateCreated": "Creado",
  "onboardingStateConsented": "Consentimiento dado",
  "onboardingStateConnectors": "Conectores creados",
  "onboardingStatePilot": "Piloto",
  "onboardingStateValidated": "Validado",
  "onboardingStateOrgWide": "Toda la organización",
  "onboardingStateOffboarding": "Baja",
  "stampingActive": "Activo",
  "stampingActivePilot": "Activo (piloto)",
  "stampingBypassed": "Omitido",
  "stampingBypassedAuto": "Omitido (automático)",
  "noReasonRecorded": "Sin motivo registrado",
  "overview": "Resumen",
  "defaultFieldsTitle": "Campos predeterminados",
  "defaultFieldsHint": "Estos valores rellenan campos de directorio vacíos para todos. Los rellenos de grupo siguen ganando para los miembros; una sobrescritura personal siempre gana.",
  "defaultFieldsSaved": "Campos predeterminados guardados.",
  "tabSettings": "Configuración",
  "tabBilling": "Facturación",
  "tabAccess": "Acceso",
  "tabDirectory": "Directorio",
  "loadTenantError": "No se pudo cargar el inquilino",
  "deleteTenant": "Eliminar inquilino",
  "deleteConfirmTitle": "¿Eliminar este inquilino?",
  "deleteConfirmBody": "Esto elimina {{name}} de las listas y del estampado. La fila se conserva para auditoría e historial de facturación.",
  "partner": "Socio",
  "noPartner": "Sin socio",
  "stampingMode": "Modo de estampado",
  "bypassReason": "Motivo de la omisión",
  "setActive": "Activar",
  "setBypass": "Omitir estampado",
  "smartHost": "Smart host",
  "verifiedDomains": "Dominios verificados",
  "snapshotVersion": "Versión de instantánea",
  "noAccessPartners": "Sin acceso a socios",
  "noAccessPartnersBody": "Los acuerdos de revendedores los gestiona el personal de OnBrand Mail.",
  "tabSignatures": "Firmas",
  "tabRules": "Reglas",
  "tabCampaigns": "Campañas",
  "tabUsers": "Usuarios",
  "tenantNotFound": "Inquilino no encontrado",
  "tenantNotFoundBody": "Este inquilino no existe, o no tienes acceso a él.",
  "openDesigner": "Abrir diseñador",
  "loadTemplatesError": "No se pudieron cargar las plantillas",
  "noTemplatesTitle": "Aún no hay plantillas",
  "noTemplatesDescription": "Diseña, publica y organiza plantillas de firma para este inquilino. Todo empieza en el diseñador.",
  "templatesAssignableHint": "Plantillas que pueden asignar las reglas de este inquilino.",
  "renderingSignaturesTitle": "Renderizando firmas",
  "renderingSignaturesBody": "Se está aplicando una publicación o un cambio de reglas a los buzones de este inquilino. Hasta que termine, los remitentes conservan la firma que ya tenían.",
  "lastRenderFailed": "El último renderizado falló",
  "retriedTimes": "Reintentado {{count}} veces.",
  "publishedDate": "publicado el {{date}}",
  "neverPublished": "nunca publicado",
  "templateStatusDraft": "Borrador",
  "templateStatusPublished": "Publicado",
  "templateStatusArchived": "Archivado",
  "openRulesEditor": "Abrir editor de reglas",
  "loadRulesError": "No se pudieron cargar las reglas",
  "noRulesTitle": "Aún no hay reglas",
  "noRulesDescription": "Sin un valor predeterminado ni una regla, no se estampa nada. Establece una firma predeterminada en Usuarios, o abre el editor de reglas para añadir una regla más específica.",
  "rulesEvalHint": "Se evalúan de arriba abajo; la primera coincidencia gana.",
  "matchesNobody": "No coincide con nadie",
  "matchesNobodyTooltip": "Un ámbito de remitentes vacío no coincide con nadie, así que esta regla nunca se dispara.",
  "newWithTemplate": "Nuevo: {{name}}",
  "newNoTemplate": "Nuevo: sin plantilla",
  "replyWithTemplate": "Respuesta: {{name}}",
  "replySameAsNew": "Respuesta: igual que nuevo",
  "primaryDefault": "Predeterminado principal",
  "defaultBadge": "Predeterminado",
  "everyone": "Todos",
  "stampingStoppedAutoTitle": "El estampado se detuvo solo",
  "stampingBypassedTitle": "El estampado está omitido",
  "stampingStoppedAutoBody": "Un nodo de flujo de correo dejó de estampar este inquilino tras fallos repetidos, a las {{when}}. Nadie lo desactivó. El correo fluye sin estampar.",
  "stampingBypassedBody": "El correo de este inquilino se retransmite sin modificar.",
  "stampingModeHint": "Omitir retransmite el correo de este inquilino sin tocarlo, manteniendo OnBrand Mail en la ruta. Úsalo cuando las firmas estén mal o falle el renderizado — no cuando el correo no pueda fluir.",
  "resumeStamping": "Reanudar estampado",
  "stampingModePermission": "Los administradores de inquilino y superiores pueden cambiar el modo de estampado.",
  "operations": "Operaciones",
  "operationsHint": "Conecta el directorio del cliente, genera conectores de Exchange y verifica la ruta de correo aquí. El comprobador de configuración revisa DNS, TLS y el relé antes de enrutar el correo por la plataforma.",
  "onboardingWizard": "Asistente de incorporación",
  "configurationTester": "Comprobador de configuración",
  "mspOperations": "Operaciones MSP",
  "mspOperationsHint": "Los incrementos de instantánea obligan a los nodos de flujo de correo a recargar reglas y plantillas. Rotar el secreto de estampado invalida el anterior: actualiza la regla de transporte del inquilino antes de que el correo se reanude.",
  "bumpSnapshot": "Incrementar instantánea",
  "snapshotBumped": "Instantánea incrementada a v{{version}}.",
  "bumpFailed": "El incremento falló.",
  "rotateStampingSecret": "Rotar secreto de estampado",
  "deleteTenantHint": "Elimina esta organización de la plataforma. El estampado se detiene de inmediato y el inquilino desaparece de todas las listas. Quita primero los conectores de Exchange y las reglas de transporte si el correo aún pasa por OnBrand Mail: la eliminación no los desmonta.",
  "bypassPlaceholder": "INC-4711 fallo de renderizado, omitido pendiente de investigación",
  "resumePlaceholder": "INC-4711 resuelto; reanudar tras canario correcto",
  "signatureRendering": "Renderizado de firmas",
  "signatureRenderingHint": "Las firmas se renderizan por buzón de antemano, de modo que estampar un mensaje es una búsqueda y no un renderizado. Publicar una plantilla o cambiar una regla lo pone en cola automáticamente.",
  "renderingNow": "Renderizando ahora",
  "queued": "En cola",
  "lastCompletedAt": "Última finalización {{when}}",
  "nothingRenderedYet": "Aún no se ha renderizado nada",
  "rerenderQueued": "Re-renderizado en cola. Las firmas se actualizan en unos segundos.",
  "rerenderFailed": "No se pudo poner en cola un re-renderizado.",
  "rerenderSignatures": "Volver a renderizar firmas",
  "rerenderPermission": "Los administradores de inquilino y superiores pueden forzar un re-renderizado.",
  "stampingBypassedToast": "Estampado omitido. El correo se retransmite sin modificar.",
  "stampingResumedToast": "Estampado reanudado.",
  "reasonRequiredHint": "Se requiere un motivo. Se muestra en el inquilino y se lee durante incidentes.",
  "updateStampingError": "No se pudo actualizar el modo de estampado",
  "bypassConfirm": "Omitir",
  "resumeConfirm": "Reanudar",
  "copySecretNowTitle": "Copia esto ahora",
  "copySecretNowBody": "El secreto se muestra una sola vez. Solo se almacena su hash. Pégalo en la regla de transporte del inquilino antes de que el correo se atribuya de nuevo.",
  "copySecretButton": "Copiar secreto",
  "rotateConfirmHint": "Rotar invalida el secreto anterior de inmediato. Escribe {{word}} para confirmar.",
  "confirmation": "Confirmación",
  "rotateSecretError": "No se pudo rotar el secreto",
  "deleteCannotUndo": "Esto no se puede deshacer desde el portal",
  "deleteWarningBody": "{{name}} ({{slug}}) desaparecerá de todas las listas de inquilinos y dejará de estamparse. Los conectores de Exchange y las reglas de transporte no se eliminan automáticamente.",
  "typeSlugToConfirm": "Escribe {{slug}} para confirmar",
  "deleteTenantError": "No se pudo eliminar el inquilino",
  "tenantDeleted": "{{name}} ha sido eliminado.",
  "noRoleBody": "No tienes un rol en este inquilino.",
  "readOnlyTitle": "Solo lectura",
  "noAccessTenantTitle": "Sin acceso a este inquilino",
  "noAccessRulesTitle": "Sin acceso a estas reglas",
  "readOnlyRulesBody": "Puedes ver las reglas y usar el comprobador, pero cambiarlas requiere el rol de Editor.",
  "noAccessDesignerTitle": "Sin acceso a este diseñador",
  "noAccessDesignerBody": "Necesitas el rol de Diseñador o superior en este inquilino para editar sus plantillas de firma.",
  "noAccessUsersTitle": "Sin acceso a estos usuarios",
  "readOnlyUsersBody": "Puedes ver buzones y firmas, pero las excepciones requieren el rol de administrador de inquilino.",
  "noAccessGroupsTitle": "Sin acceso a estos grupos",
  "readOnlyGroupsBody": "Puedes ver grupos sincronizados, pero las excepciones requieren el rol de administrador de inquilino.",
  "noAccessCampaignsTitle": "Sin acceso a estas campañas",
  "readOnlyCampaignsBody": "Puedes ver campañas, pero crearlas o modificarlas requiere el rol de Editor."
}
